import { state } from "../../state/workspaceStore.js";
import { field, btn, check } from "../forms/FormControls.jsx";
import { nodes } from "../common/reactHelpers.jsx";
import { esc } from "../../utils/format.js";
import { product } from "../../utils/domain/model.js";
export function applicableProducts(c) {
  const active = state.db.products.filter(
      (p) => p.status === "Active" && !p.archived,
    ),
    visible = active.filter((p) =>
      `${p.id} ${p.name} ${p.skus.map((s) => s.code).join(" ")}`
        .toLowerCase()
        .includes(state.couponSearch.toLowerCase()),
    ),
    unavailable = (c.productIds || []).filter(
      (pid) => !active.some((p) => p.id === pid),
    );
  state.lastProductOptions = [...visible.map((p) => p.id), ...unavailable];
  return (
    <>
      {field(
        "Search applicable products",
        "couponSearch",
        state.couponSearch,
        "search",
        'id="coupon-search"',
      )}
      <div className={"selection-actions"}>
        {btn(
          "Select all active products",
          'data-action="select-products"',
          true,
        )}
        {btn("Clear Selection", 'data-action="clear-products"', true)}
        <span className={"hint"}>
          {(c.productIds || []).length}
          {" selected"}
        </span>
      </div>
      <div className={"applicable-products"}>
        {nodes(
          visible.map((p) =>
            check(
              <span>
                <b>{esc(p.name)}</b>
                <small>
                  {esc(p.id + " · " + p.skus.map((s) => s.code).join(", "))}
                </small>
              </span>,
              "product-" + p.id,
              c.productIds.includes(p.id),
            ),
          ),
        ) || <p className={"empty"}>{"No matching active products."}</p>}
        {nodes(
          unavailable.map((pid) =>
            check(
              <span>
                {esc(
                  product(state.db, pid)?.name || "Removed product · " + pid,
                )}
                <small>
                  {
                    "Unavailable; retained selection does not discount this product. Uncheck to remove."
                  }
                </small>
              </span>,
              "product-" + pid,
              true,
            ),
          ),
        )}
      </div>
    </>
  );
}
